import React from "react";
import { Button, Typography, Container } from "@material-ui/core";
import useStyles from "./styles";

const BanPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.bodyStyle}>
      <Container maxWidth="md">
        <Typography
          className={classes.typographyStyle}
          variant="h5"
          align="center"
          gutterBottom
        >
          Du har registrerat en leverantörsadress! <br></br>
          <br></br>Som utställare ska du registrera dig&nbsp;
          {<a href="https://event.agi.se/se/exhibitor">HÄR</a>}, så att du även
          kan komma in under uppbyggnad och tidigare på morgonen.
        </Typography>
        <Typography
          className={classes.typographyStyle}
          variant="body1"
          align="center"
          gutterBottom
        >
          Sign&Print Scandinavia välkomnar alla kunder - direkt och indirekta -
          till utställarna. <br></br>Är du leverantör och ännu inte bokat plats
          på mässan?
        </Typography>
        <Typography
          className={classes.typographyStyle}
          align="center"
          gutterBottom
        >
          <Button
            href="https://signochprint.se/boka-en-monter/"
            variant="contained"
            color="primary"
          >
            Boka en monter här
          </Button>
        </Typography>
      </Container>
    </div>
  );
};

export default BanPage;
